import { resetComponent } from '../../style';
import { genStyleHooks } from '../../theme/internal';
import type { AliasToken, GenerateStyle } from '../../theme/internal';
import { blue, gray } from '../../theme/themes/colorPalette';

// biome-ignore lint/suspicious/noEmptyInterface: ComponentToken need to be empty by default
export interface ComponentToken {}
export interface ChipsTriggerToken extends AliasToken {
  componentCls: string;
}

export const initChipsTriggerToken = (token: AliasToken): ChipsTriggerToken => ({
  ...token,
  componentCls: '.youlify-chips',
});

const genChipsStyle: GenerateStyle<ChipsTriggerToken> = (token) => {
  const { componentCls } = token;
  return {
    [componentCls]: {
      ...resetComponent(token),
      display: 'inline-flex',
      gap: 8,
      alignItems: 'center',
      padding: '12px 16px',
      fontSize: 12,
      fontWeight: 500,
      borderRadius: 1000,
      border: `1px solid ${gray[100]}`,
      cursor: 'pointer',
      transition: 'all 0.2s',

      '&-icon': {
        fontSize: 12,
        display: 'flex',
        alignItems: 'center',
      },

      '&-label': {
        flex: 1,
      },

      '&-close': {
        display: 'flex',
        fontSize: 12,
        cursor: 'pointer',

        '&-icon': {
          fontSize: 16,
        },
      },

      '&:not(&-selected):hover': {
        borderColor: blue[100],
      },

      '&-selected': {
        background: blue[200],
        borderColor: 'transparent',
        color: gray[900],
      },

      '&-disabled': {
        color: gray[500],
        cursor: 'not-allowed',
        padding: '12px 16px',
      },
      '&-disabled&-selected': {
        background: gray[100],
        borderColor: 'transparent',
        color: gray[500],
      },

      '&-pressed': {
        transform: 'scale(0.96)',
        backgroundColor: blue[300],
        border: '1px solid transparent',
      },

      '&-large': {
        padding: '12px 24px',
        fontSize: 16,
        gap: 12,

        [`& .${token.componentCls}-icon`]: {
          fontSize: 16,
        },
        [`& .${token.componentCls}-close`]: {
          fontSize: 16,
        },
      },
    },
  };
};

export const useChipsStyle = genStyleHooks('Chips', (token) => [genChipsStyle(token)], undefined, {
  resetFont: false,
});
